import { api } from '../../apiClient';

// City API service functions
export const cityService = {
  // Get all cities
  getAllCities: async () => {
    const response = await api.get('/city');
    return response.data;
  },

  // Get city by ID
  getCityById: async (cityId) => {
    const response = await api.get(`/city/${cityId}`);
    return response.data;
  },

  // Create city
  createCity: async (cityData) => {
    const response = await api.post('/city', cityData);
    return response.data;
  },

  /** Find or create city by name (case-insensitive); requires auth */
  ensureCity: async (payload) => {
    const response = await api.post('/city/ensure', payload);
    return response.data;
  },

  // Update city
  updateCity: async (cityId, cityData) => {
    const response = await api.patch(`/city/${cityId}`, cityData);
    return response.data;
  },

  // Delete city
  deleteCity: async (cityId) => {
    const response = await api.delete(`/city/${cityId}`);
    return response.data;
  },
};

export default cityService;
